import { Col } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const CaseSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const status = symptoms.caseType?.status

  if (!status) return null

  return (
    <Col span={24}>
      <Text>
        12.{' '}
        {status === 'singleCase'
          ? t('epidemiology.symptoms.caseType.singleCase')
          : t('epidemiology.symptoms.caseType.outbreakCase')}
      </Text>
    </Col>
  )
}
